// @ts-nocheck
// Override service calls to check for window.Peerius

export function sendTracking(json: string) {
    if (!window.Peerius) {
        return;
    }
    window.Peerius.sendAjax(`rest.pagex?jd=${json}`, window.PeeriusCallbacks.apiVersion);
}

export function sendImpressionTracking(peeriusSiteName: string, recommendationIds: number[]) {
    if (!window.Peerius) {
        return;
    }
    window.Peerius.sendAjax(`${peeriusSiteName}/rec/shown.pagex?ids=${recommendationIds.join(",")}`);
}

export function sendProductRecommendationTracking(recommendationId: number, isNewPageWasOpen: boolean) {
    if (!window.Peerius) {
        return;
    }
    if (isNewPageWasOpen) {
        window.Peerius.smartRecsClick(recommendationId);
    } else {
        window.Peerius.smartRecsSendClick(recommendationId);
    }
}
